<template>
  <BreadCrumb PageTitle="Link" />
  <LinkContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import LinkContent from "../../template-components/Utilities/Link/LinkContent.vue";

export default defineComponent({
  name: "LinkPage",
  components: {
    BreadCrumb,
    LinkContent,
  },
});
</script>